module.exports = __webpack_public_path__ + "static/media/trash_can_black.62b97473.svg";